export default "__VITE_ASSET__41098723__"